  <!--Loading Spinner-->
  <div *ngIf="inProgress">
    <app-spinner></app-spinner>
 </div>
 <!-- Content Header (Page header) -->
 <section class="content-header">
    <div class="content-header">
       <div class="container-fluid">
         <div class="row mb-2">
           <div class="col-sm-6">
               <h3>Add Consolidated Entry</h3>
           </div>
           <div class="col-sm-6">
             <ol class="breadcrumb float-sm-right">
               <li class="breadcrumb-item"><a routerLink="/"><i class="nav-icon fas fa-tachometer-alt"></i>&nbsp;Dashboard</a></li>
               <li class="breadcrumb-item active">Add Consolidated Entry</li>
             </ol>
           </div><!-- /.col -->
         </div><!-- /.row -->
       </div><!-- /.container-fluid -->
   </div>
   </section>
     <!-- /.content-header -->
   <section class="content">
   <div class="container-fluid">
   <div class="card">
       <div class="card-header">
         <h3 class="card-title">Add Consolidated Entry</h3>
         <!--Error messages-->
         <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
            {{errorMessage}}
          </div>
          <!--Warning messages-->
         <div class="alert alert-warning" role="alert" *ngIf="warningMessage">
            {{warningMessage}}
         </div>
       </div>
       <!-- /.card-header -->
       <div class="card-body">
           <form [formGroup]="form" (ngSubmit)="handleSubmit()">
               <div class="row clearfix">
                   <div class="col-md-4">
                       <div class="form-group">
                          <label>BL No.:</label>
                          <ng-select [(ngModel)]="selectedBL" [ngModelOptions]="{standalone: true}" (change)="onSelectChange()">
                            <ng-option *ngFor="let bl of billsOfLading" [value]="bl.bl_id">{{bl.bl_no}}</ng-option>
                          </ng-select>
                       </div>
                   </div>
                   <div class="col-md-4">
                       <div class="form-group">
                           <label>Consignee:</label>
                           <input type="text" class="form-control" value="{{ bl_data?.data?.consignee_name }}" readonly>
                       </div>
                   </div>
                   <div class="col-md-4">
                       <div class="form-group">
                           <label>No. of Units:</label>
                           <input type="text"  class="form-control" value="{{ bl_data?.data?.no_of_units }}" readonly>
                       </div>
                   </div>
               </div>
               <div class="row clearfix">
                  <div class="col-md-4">
                    <div class="form-group">
                        <label>Entry No.:<span style="color:red;">*</span></label>
                        <input type="text"  formControlName="entry_no" class="form-control" placeholder="Entry No." value="" [(ngModel)]="entryNo">

                        <span *ngIf="submitted && form.get('entry_no')?.hasError('required')" style="color:red"> <strong>Please enter entry number!</strong></span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                        <label>Entry Date:<span style="color:red;">*</span></label>
                        <input type="date" formControlName="entry_date" class="form-control" placeholder="Entry Date" value="">

                        <span *ngIf="submitted && form.get('entry_date')?.hasError('required')" style="color:red"> <strong>Please enter or select entry date!</strong></span>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                        <label>Duty Amount:<span style="color:red;">*</span></label>
                        <input type="text" formControlName="duty_amount"  class="form-control" placeholder="Duty Amount" value="">

                        <span *ngIf="submitted && form.get('duty_amount')?.hasError('required')" style="color:red"> <strong>Please enter duty amount!</strong></span>
                    </div>
                  </div>
               </div>
               <div class="row clearfix">
                  <div class="col-md-4">
                    <div class="form-group">
                        <label>Attach Entry (PDF Only):<span style="color:red;">*</span></label>
                        <div class="input-group mb-3">
                            <div class="custom-file">
                              <input type="file" formControlName="entry_attachment" accept="application/pdf" class="custom-file-input" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01" (change)="onEntryFileSelected($event)">
                              <label class="custom-file-label" for="inputGroupFile01">{{ entryFileName }}</label>
                            </div>
                        </div>

                        <span *ngIf="submitted && form.get('entry_attachment')?.hasError('required')" style="color:red"> <strong>Please attach Entry!</strong></span>
                    </div>
                  </div>
                  <div class="col-md-4">
                      <div class="form-group">
                          <label>Attach Payment Slip (PDF Only):<span style="color:red;">*</span></label>
                          <div class="input-group mb-3">
                              <div class="custom-file">
                                <input type="file" formControlName="pmt_slip_attachment" accept="application/pdf" class="custom-file-input" id="inputGroupFile01" aria-describedby="inputGroupFileAddon01" (change)="onPaymentSlipFileSelected($event)">
                                <label class="custom-file-label" for="inputGroupFile01">{{ pmtSlipFileName }}</label>
                              </div>
                          </div>

                          <span *ngIf="submitted && form.get('pmt_slip_attachment')?.hasError('required')" style="color:red"> <strong>Please attach Payment Slip!</strong></span>
                      </div>
                  </div>
               </div>
               <div class="separator">Payment Details</div>
                <div class="row clearfix">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Document Reference:<span style="color:red;">*</span></label>
                            <input type="text" formControlName="doc_ref_no" [(ngModel)]="docRefNo" class="form-control" placeholder="Document Reference Number" value="" (click)="copyEntryNo()">

                            <span *ngIf="submitted && form.get('doc_ref_no')?.hasError('required')" style="color:red"> <strong>Please enter Document Reference Number!</strong></span>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Payment Ref. Number:<span style="color:red;">*</span></label>
                            <input type="text" formControlName="payment_ref_no" class="form-control" placeholder="Payment Reference Number" value="">

                            <span *ngIf="submitted && form.get('payment_ref_no')?.hasError('required')" style="color:red"> <strong>Please enter Payment Reference Number!</strong></span>
                        </div>
                    </div>
                </div>
                <div class="separator">Options</div>
                <div class="row clearfix">
                  <div class="col-md-6 d-flex align-items-center gap-2">
                    <input type="checkbox" formControlName="has_rad" class="custom-checkbox">&nbsp;&nbsp;
                    <label class="mb-0">Has Radiation</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <input type="checkbox" formControlName="has_idf" class="custom-checkbox">&nbsp;&nbsp;
                    <label class="mb-0">Has IDF</label>
                  </div>
                </div><br>
                <button class="btn btn-success" type="button" *ngIf="isProcessing; else showSaveBtn" disabled>
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Processing...
                </button>

                <ng-template #showSaveBtn>
                    <button type="submit" class="btn btn-success"><i class="fa fa-save" aria-hidden="true">&nbsp;</i>Save</button>
                </ng-template>
           </form><br>
           <table id="example1" class="table table-bordered table-hover">
            <thead>
                <tr>
                    <th>Make</th>
                    <th>Model</th>
                    <th>Chassis No.</th>
                    <th>Engine No.</th>
                    <th>Engine CC</th>
                    <th>Transmission</th>
                    <th>Body Type</th>
                    <th>Drive</th>
                    <th>Fuel</th>
                    <th>Mileage</th>
                    <th>Colour</th>
                    <th>Yr of Mfg</th>
                    <th>Weight</th>
                    <th>CBM</th>
                </tr>
            </thead>
            <tbody>
               <tr *ngFor="let vehicle of vehicles">
                    <td>{{ vehicle.make }}</td>
                    <td>{{ vehicle.model }}</td>
                    <td>{{ vehicle.chassis_no }}</td>
                    <td>{{ vehicle.engine_no }}</td>
                    <td>{{ vehicle.engine_cc }}</td>
                    <td>{{ vehicle.transmission }}</td>
                    <td>{{ vehicle.body_type }}</td>
                    <td>{{ vehicle.drive }}</td>
                    <td>{{ vehicle.fuel }}</td>
                    <td>{{ vehicle.mileage }}</td>
                    <td>{{ vehicle.colour}}</td>
                    <td>{{ vehicle.year }}</td>
                    <td>{{ vehicle.weight }}</td>
                    <td>{{ vehicle.cbm}}</td>
               </tr>
            </tbody>
          </table>
       </div>
       <!-- /.card-body -->
   </div>
   </div>
   </section>
